import { useSupportStats } from "hooks/fetch/useSupportStats";
import { LoadingSpinner } from "components/LoadingSpinner";
import { Container, StatItem, StatLabel, StatValue, WeightBar, WeightFill, AlertBadge } from "./styles";

type Props = {
  categoryId: string;
};

export function SupportStatsPanel({ categoryId }: Props) {
  const { data: stats, isLoading } = useSupportStats(categoryId);

  if (isLoading) return <LoadingSpinner size={20} thickness={2} />;
  if (!stats) return null;

  return (
    <Container>
      <StatItem>
        <StatLabel>Disponibilidade</StatLabel>
        <StatValue available={stats.availability_rate >= 50}>
          {stats.availability_rate}%
        </StatValue>
        {stats.all_unavailable && (
          <AlertBadge>⚠ Todos indisponíveis</AlertBadge>
        )}
      </StatItem>

      {stats.agents.map((agent) => {
        const effectivelyAvailable = agent.is_available && !agent.has_active_absence;
        return (
          <StatItem key={agent.user_id}>
            <StatLabel>
              {agent.user_name ?? 'Agente'}
              {!effectivelyAvailable && <span> (indisponível)</span>}
            </StatLabel>
            <WeightBar title={`Peso: ${agent.weight_pct}%`}>
              <WeightFill pct={agent.weight_pct} />
            </WeightBar>
            <StatValue available={effectivelyAvailable}>{agent.weight_pct}%</StatValue>
          </StatItem>
        );
      })}
    </Container>
  );
}
